import { render, staticRenderFns } from "./chemReviewCheck.vue?vue&type=template&id=08717582"
import script from "./chemReviewCheck.vue?vue&type=script&lang=js"
export * from "./chemReviewCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08717582')) {
      api.createRecord('08717582', component.options)
    } else {
      api.reload('08717582', component.options)
    }
    module.hot.accept("./chemReviewCheck.vue?vue&type=template&id=08717582", function () {
      api.rerender('08717582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewCheck.vue"
export default component.exports